module.exports = __webpack_public_path__ + "static/media/mern.63096f12.png";